export const EMPTY = Object.seal({});
// let _SubscriptionSpy = []
// export const spySubscriptions = (fn: Function) : Subscription[] => {
//     // TODO
//     return []
// }
// let _AutoSubscriber : Subscriber<any> = null
// export const checkAutoSubscriber = () : Subscriber<any> => {
//     return _AutoSubscriber
// }
export const defaultUidFunc = (v) => {
    if (v == null) {
        return undefined;
    }
    let uid = undefined;
    if (typeof v == 'string' || typeof v == 'number' || typeof v == 'boolean' || typeof v == 'symbol') {
        uid = String(v);
    }
    else if (v.id != null) {
        uid = String(v.id);
    }
    else {
        //        console.warn('Uid function should be defined', v)
    }
    if (uid == '[object Object]') {
        console.warn('Uid should be a primitive value', uid, v);
    }
    return uid;
};
export const isEventBus = (v) => {
    return v != null && v.$hasEvent != undefined;
};
export const isSubscriptionProvider = (v) => {
    return v.$subscriptions != null;
};
